import {createLargeSvgIcon} from './utils'

export default createLargeSvgIcon(
  <>
    <g clipPath="url(#clip0_1493_25)">
      <mask
        height="41"
        id="mask0_1493_25"
        maskUnits="userSpaceOnUse"
        style={{maskType: 'alpha'}}
        width="40"
        x="0"
        y="0"
      >
        <path
          d="M0 19.2002C0 12.4796 0 9.1193 1.30792 6.55236C2.4584 4.29441 4.29417 2.45865 6.55211 1.30817C9.11905 0.000244141 12.4794 0.000244141 19.2 0.000244141H20.8C27.5206 0.000244141 30.8809 0.000244141 33.4479 1.30817C35.7058 2.45865 37.5416 4.29441 38.6921 6.55236C40 9.1193 40 12.4796 40 19.2002V20.8002C40 27.5209 40 30.8812 38.6921 33.4481C37.5416 35.7061 35.7058 37.5418 33.4479 38.6923C30.8809 40.0002 27.5206 40.0002 20.8 40.0002H19.2C12.4794 40.0002 9.11905 40.0002 6.55211 38.6923C4.29417 37.5418 2.4584 35.7061 1.30792 33.4481C0 30.8812 0 27.5209 0 20.8002V19.2002Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1493_25)">
        <rect fill="#FF0000" height="40" width="40" y="0.000244141" />
        <path
          d="M8.46144 15.1813H6.34082L6.31363 21.3936L5.17175 24.8328H7.31957L8.40707 21.5567L12.5668 15.1813H10.1607L8.78769 17.7097C8.52941 18.1719 8.3255 18.5933 8.25753 18.7564C8.28472 18.5797 8.3255 18.036 8.35269 17.5874L8.46144 15.1813Z"
          fill="white"
        />
        <path
          d="M8.17725 24.8328H10.3658L11.1815 23.0928H12.9079L12.6088 24.8328H14.6751L16.0752 15.1813H13.1797L8.17725 24.8328ZM13.2341 21.2713H12.0515L13.506 18.1719C13.7371 17.6961 13.9138 17.2611 13.9818 17.098C13.9546 17.2747 13.8458 17.8049 13.7643 18.2535L13.2341 21.2713Z"
          fill="white"
        />
        <path
          d="M20.4221 15.1813H18.084L14.8759 24.8328H16.847L18.5054 19.7896C18.6821 19.2866 18.8045 18.838 18.8589 18.6749C18.8453 18.8516 18.7909 19.3953 18.7637 19.8439L18.4646 24.8328H20.7484L23.9565 15.1813H21.9854L20.4085 19.9799C20.2318 20.4828 20.1095 20.9314 20.0551 21.0946C20.0687 20.9178 20.1095 20.3741 20.1367 19.9255L20.4221 15.1813Z"
          fill="white"
        />
        <path
          d="M26.3311 21.1897L26.2903 21.3121C25.9912 22.2228 25.5018 23.2424 24.9037 23.2424C24.224 23.2424 24.4823 21.6247 25.0532 19.8847C25.8553 17.4378 26.3447 16.7446 26.902 16.7446C27.2147 16.7446 27.4186 17.0572 27.4865 18.1583L29.4032 17.5194C29.3217 16.1192 28.6556 14.991 27.1059 14.991C25.3251 14.991 23.9114 16.4999 22.919 19.5313C22.0082 22.318 22.0898 24.9008 24.0065 24.9008C24.6726 24.9008 25.1348 24.6425 25.6106 24.058L25.4747 24.8328H27.0107L28.8323 19.3682H25.8961L25.2979 21.1897H26.3311Z"
          fill="white"
        />
        <path
          d="M30.898 25.0096C32.5701 25.0096 34.0382 23.5142 35.0169 20.4828C35.9277 17.6961 35.9141 15.0046 33.2905 15.0046C31.6185 15.0046 30.1504 16.4999 29.1716 19.5313C28.2608 22.318 28.2744 25.0096 30.898 25.0096ZM31.1155 23.2832C30.2999 23.2832 30.7757 21.4888 31.3058 19.8847C32.1079 17.3971 32.6108 16.731 33.073 16.731C33.8751 16.731 33.4129 18.4982 32.8827 20.1294C32.0807 22.6171 31.5777 23.2832 31.1155 23.2832Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1493_25">
        <rect fill="white" height="40" transform="translate(0 0.000244141)" width="40" />
      </clipPath>
    </defs>
  </>,
  'YangoIcon',
)
